import { render, staticRenderFns } from "./rcategories.vue?vue&type=template&id=2282bfdd"
import script from "./rcategories.vue?vue&type=script&lang=ts"
export * from "./rcategories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports